import { render } from "./content2.vue?vue&type=template&id=72a65a36&scoped=true"
import script from "./content2.vue?vue&type=script&lang=js"
export * from "./content2.vue?vue&type=script&lang=js"

import "./content2.vue?vue&type=style&index=0&id=72a65a36&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a65a36"]])

export default __exports__